import { createSelector } from 'reselect';

import { COUNTRY } from 'common/constants';
import { selectDataClinicCountry, selectDataInsuranceList, selectDataInsuranceListForCanada } from 'connect/selectors';

type State = { data: Record<string, any>; };

export const selectRequestedAppointment = (state: State) => (state.data.requestedAppointment);

export const selectAnyProviderSelected = (state: State) => (state.data.requestedAppointment?.anyProviderSelected);

export const selectInsuranceListForClinicCountry = createSelector(
  selectDataClinicCountry,
  selectDataInsuranceList,
  selectDataInsuranceListForCanada,
  (clinicCountry, insuranceList, insuranceListForCanada) => {
    if (clinicCountry === COUNTRY.unitedStates) {
      return insuranceList;
    }

    return insuranceListForCanada;
  },
);
